import { SaleLine_VARIABLE } from 'apis/GraphQL/Variables/saleLine';
import { ICheckValidDateRoute, IGetValidRouteById } from 'interfaces/SaleLine';
import {
  CHECK_VALID_DATE_ROUTE_MAIN,
  CHECK_VALID_ROUTE_BY_ID,
  GET_LIST_ROUTE,
  GET_VALID_ROUTE_BY_ID,
  ICheckValidRouteById,
  IGetListRouteParams,
  IGetRouteDetail,
  ISearchRouteComboBox,
  IUpdateRouteDetail,
  QUERY_GET_LIST_ROUTE_COMBO_BOX,
  QUERY_GET_ROUTE_COMBOBOX,
  QUERY_GET_ROUTE_DETAIL,
  UPDATE_MANY_ROUTE_DETAIL,
  UPDATE_MANY_ROUTE_DETAIL_VARIABLES,
  VARIABLE_GET_ALL_ROUTE_COMBOBOX,
  VARIABLE_GET_LIST_ROUTE,
  VARIABLES_CHECK_VALID_ROUTE_BY_ID,
  VARIABLES_GET_LIST_ROUTE_COMBO_BOX,
  VARIABLES_GET_ROUTE_DETAIL,
} from './GraphQL/Queries/saleLineQuery';
import axiosGraphQL from './GraphQL/axiosGraphQL';

export const SaleLineApi = {
  getListRoute: async (params: IGetListRouteParams) => {
    return await axiosGraphQL.post('graphql', {
      query: GET_LIST_ROUTE,
      variables: VARIABLE_GET_LIST_ROUTE(params),
    });
  },
  getAllComboBox: async () => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_GET_ROUTE_COMBOBOX,
      variables: VARIABLE_GET_ALL_ROUTE_COMBOBOX,
    });
  },
  getAllRouteComboBox: async (params: ISearchRouteComboBox) => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_GET_LIST_ROUTE_COMBO_BOX,
      variables: VARIABLES_GET_LIST_ROUTE_COMBO_BOX(params),
    });
  },
  checkValidRouteById: async (params: ICheckValidRouteById) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_VALID_ROUTE_BY_ID,
      variables: VARIABLES_CHECK_VALID_ROUTE_BY_ID(params),
    });
  },
  getValidRouteById: async (params: IGetValidRouteById) => {
    return await axiosGraphQL.post('/graphql', {
      query: GET_VALID_ROUTE_BY_ID,
      variables: SaleLine_VARIABLE.getValidRouteById(params),
    });
  },
  checkValidDateRoute: async (params: ICheckValidDateRoute) => {
    return await axiosGraphQL.post('/graphql', {
      query: CHECK_VALID_DATE_ROUTE_MAIN,
      variables: SaleLine_VARIABLE.checkValidDateRoute(params),
    });
  },
  getRouteDetail: async (params: IGetRouteDetail) => {
    return await axiosGraphQL.post('/graphql', {
      query: QUERY_GET_ROUTE_DETAIL,
      variables: VARIABLES_GET_ROUTE_DETAIL(params),
    });
  },
  updateManyRouteDetail: async (params: IUpdateRouteDetail[]) => {
    return await axiosGraphQL.post('/graphql', {
      query: UPDATE_MANY_ROUTE_DETAIL,
      variables: UPDATE_MANY_ROUTE_DETAIL_VARIABLES(params),
    });
  },
};
